import React from 'react';
import '../styles/LoadingSpinner.css';

const LoadingSpinner = () => {
    return (
        <div className="spinner-overlay">
            <img src="/animations/loadingspinner.gif" alt="Loading..." className="spinner-image" />
        </div>
    );
};

export default LoadingSpinner;
